import axios, { AxiosResponse } from "axios";
const responseBody = <T>(response: AxiosResponse<T>) => {
                          if(response.data) {
                            return response.data;
                          } else {
                            throw new Error("An unexpected error has occurred");
                          }
                    };
const requests = {
    get: <T>(url: string) => axios.get<T>(url).then(responseBody),
    postWithoutBody: <T>(url: string) => axios.post<T>(url).then(responseBody),
    post: <T>(url: string, body: Record<string, unknown>) => axios.post<T>(url, body).then(responseBody),
    put: <T>(url: string, body: Record<string, unknown>) => axios.put<T>(url, body).then(responseBody),
    del: <T>(url: string) => axios.delete<T>(url).then(responseBody)
}

export { requests }
